import { useCallback } from 'react';
import { useQueryPanelStore } from '@/stores';

export function useQueryAttachment() {
    const attachmentFile = useQueryPanelStore((s) => s.attachmentFile);
    const uploadPreviewUrl = useQueryPanelStore((s) => s.uploadPreviewUrl);
    const uploadingFileName = useQueryPanelStore((s) => s.uploadingFileName);
    const isUploading = useQueryPanelStore((s) => s.isUploading);
    const uploadProgress = useQueryPanelStore((s) => s.uploadProgress);
    const attachFile = useQueryPanelStore((s) => s.attachFile);
    const clearAttachmentFile = useQueryPanelStore(
        (s) => s.clearAttachmentFile,
    );

    const handleAttach = useCallback(
        async (params: { file: File }) => {
            if (!params?.file) {
                console.error('No file provided to handleAttach');
                return;
            }
            await attachFile(params.file);
        },
        [attachFile],
    );

    const handleRemove = useCallback(() => {
        clearAttachmentFile();
    }, [clearAttachmentFile]);

    const uploadAttachment = useCallback(async (): Promise<
        { url: string; filename: string } | undefined
    > => {
        return attachmentFile;
    }, [attachmentFile]);

    return {
        attachmentFile,
        isUploading,
        uploadingFileName,
        uploadProgress,
        uploadPreviewUrl,
        handleAttach,
        handleRemove,
        uploadAttachment,
    };
}
